import React from 'react'
import css from './styles.module.scss'
import HeroTitle from 'components/typo/HeroTitle'
import Text from 'components/typo/Text'
import BenefitCard from 'src/components/shared/BenefitCard'

const ContactHeader = ({ upperTitle, title, description, benefitsCards }) => {
  return (
    <div className={css.wrapper}>
      <div className={css.header}>
        <Text className={css.upperTitle}>{upperTitle}</Text>
        <HeroTitle tag="h1">{title}</HeroTitle>
        <Text className={css.description}>{description}</Text>
      </div>
      {benefitsCards && (
        <div className={css.benefits}>
          {benefitsCards.map((benefit) => (
            <BenefitCard
              {...benefit}
              alignCenter={false}
              shadow={true}
              isColumn={true}
              smallTitle={false}
            />
          ))}
        </div>
      )}
    </div>
  )
}

export default ContactHeader
